// Service category configuration for calendar views
export const CATEGORY_CONFIG = {
  MOT: { 
    letter: 'M', 
    color: '#1976d2', 
    name: 'MOT Tests',
    description: 'Ministry of Transport Tests'
  },
  Services: { 
    letter: 'S', 
    color: '#2e7d32', 
    name: 'Services',
    description: 'General vehicle services'
  },
  Valeting: { 
    letter: 'V', 
    color: '#ed6c02', 
    name: 'Valeting',
    description: 'Vehicle cleaning and detailing'
  },
  Repairs: { 
    letter: 'R', 
    color: '#d32f2f', 
    name: 'Repairs',
    description: 'Vehicle maintenance and repairs'
  },
  Others: {
    letter: 'O',
    color: '#7b1fa2',
    name: 'Others',
    description: 'Custom services'
  }
};

// Get all available categories as an array
export const CATEGORIES = Object.keys(CATEGORY_CONFIG);

// Get category style information for a service
export const getCategoryStyle = (service, isProduct = true) => {
  const category = service?.category;
  
  if (category && CATEGORY_CONFIG[category]) {
    return {
      letter: CATEGORY_CONFIG[category].letter,
      color: CATEGORY_CONFIG[category].color,
      name: CATEGORY_CONFIG[category].name
    };
  }
  
  return null;
};